// const headerState = {
//   NEW: 1,
//   CANCELLED: 2,
//   INCOMPLETE: 3,
//   COMPLETED: 4
// }

const headerState = {
  OPEN_ORDER: 1,
  PARTIAL_ORDER: 2,
  COMPLETE_ORDER: 3
}

// const detailState = {
//   INVOICE_PENDING: 1,
//   INCOMPLETE: 2,
//   COMPLETED: 3
// }

const detailState = {
  PENDING_RECEIPT: 1,
  PARTIAL_RECEIPT: 2,
  COMPLETE_RECEIPT: 3
}

// const invoiceState = {
//   PROCESSED: 1,
//   PENDING_VALIDATION: 2,
//   VALIDATED: 3
// }

const invoiceState = {
  PENDING_WAREHOUSE_VALIDATION: 1,
  PENDING_FINANCE_VALIDATION: 2,
  VALIDATED_INVOICE: 3,
  REJECTED: 4
}

export { headerState, detailState, invoiceState }
